module.exports = __webpack_public_path__ + "media/images/emblems/Lungern-coat_of_arms-2d5e0a90b9c4f8cab550ee56d6dfcef4.svg";